import React, { useState, useEffect } from "react";
import { Container, Row, Col, FormGroup, Label, Input, Table } from "reactstrap";

import { Formik, Field, Form, FieldArray } from "formik";
import * as Yup from "yup";
import "../share/form.css";
import Swal from 'sweetalert2'
import { DatePickerInput } from "../share/DatePickerInput";
import { GetProvince, GetIndustrial, GetTitleName } from "../share/api/MasterDataApi";
import { CustomInputNumeric } from '../share/CustomInputNumeric'
import { NumericFormat } from 'react-number-format';
import { Loading } from "../share/loading";
import { AddEditAuthorizedModal } from "../RegisterSystem/AddEditAuthorizedModal";
import { BsPlusLg } from "react-icons/bs";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit3 } from "react-icons/fi";

export function ProfileCorporateComponent() {
    let rootColorErrors = "#d33";
    let rootColorPrimary = "#0A66C2";
    const user = JSON.parse(localStorage.getItem("userData"));
    const [loading, setLoading] = useState(false);
    const [profileData, setProfileData] = useState(null);
    // console.log("profileData", profileData);

    const [titleName, setTitleName] = useState([]);
    const [locationProvince, setLocationProvince] = useState([]);
    const [locationAmphur, setLocationAmphur] = useState([]);
    const [locationTumbon, setLocationTumbon] = useState([]);
    const [industrialData, setIndustrialData] = useState([]);
    const [industryData, setIndustryData] = useState([]);
    const [dataCertificate, setDataCertificate] = useState(null);

    //เก็บข้อมูลผู้มีอำนาจเดิม และหากมีการแก้ไขข้อมูล จะเก็บข้อมูลไฟล์แนบ
    const [originalAuthorizedList, setOriginalAuthorizedList] = useState([]);
    const [registerationDoc, setRegisterationDoc] = useState(null);


    useEffect(() => {
        const getProfile = async () => {
            try {
                const res = await fetch("/api/Profile/getProfile", {
                    method: "POST",
                    headers: { 'token': user.token },
                })
                const resJson = await res.json();
                resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
                setProfileData(resJson.dataenum);
                setOriginalAuthorizedList(resJson.dataenum.authRegister);
                // console.log("resJson", resJson);
            } catch (e) {
                // console.log("err", e)
            }
        };
        getProfile();
    }, [])

    // useEffect(() => {
    //     setListProvince(locationProvince);
    // }, [locationProvince])

    useEffect(() => {
        // setLoading(true)
        // GetVMdDept({ setDeptsData, setLoading }) //ดึงmaster data หน่วยงานกรมพัฒฯ
        GetProvince({ setLocationProvince, setLoading }) // ดึง master data จังหวัด
        GetIndustrial({ setIndustrialData, setLoading }) // ดึงmaster data ประเภทอุตสาหกรรม 2 หลัก
        GetTitleName({ setTitleName, setLoading }) //ดึงคำนำหน้าชื่อ

    }, []);


    // submit แบบฟอร์ม
    const onSubmit = async (values) => {

        console.log("values", values);
        let postData = new FormData();

        Object.entries(values).forEach(([key, value]) => {
            if (key === "authorizedList") {
                postData.append(key, JSON.stringify(value));
            } else if (key === "registerTypeId") {

            } else {
                postData.append(key, value);
            }
        });
        try {
            let res = await fetch("/api/Profile/requestChangeProfile", {
                method: "POST",
                headers: { 'token': user.token },
                body: postData
            });

            let resJson = await res.json();

            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "โปรดรอเจ้าหน้าที่ตรวจสอบและและยืนยันผ่านทางอีเมล",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload()
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            console.log(e)
        }

    }

    const validateSchema = Yup.object().shape({
        address: Yup.object({
            addressNo: Yup.string().required("กรุณากรอกเลขที่อยู่"),
        }),
        // addNo: Yup.string().required("กรุณากรอกเลขที่"),
        // addProvince: Yup.string().required("กรุณาเลือกจังหวัด"),
        // addDistrict: Yup.string().required("กรุณาเลือกอำเภอ/เขต"),
        // addTumbon: Yup.string().required("กรุณาเลือกตำบล/แขวง"),
        // postcode: Yup.string()
        //     .matches(/^[0-9]{5}$/, "รหัสไปรษณีย์ต้องประกอบไปด้วยตัวเลข 5 หลัก")
        //     .required("กรุณาระบุรหัสไปรษณีย์"),
        // tel: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),

        // fax: Yup.string(),

        // email: Yup.string()
        //     .email("รูปแบบอีเมลไม่ถูกต้อง")
        //     .required("กรุณากรอกอีเมล"),
        // contactName: Yup.string().required("กรุณากรอกชื่อ-นามสกุลผู้ประสานงาน"),
        // contactNo: Yup.string().required("กรุณากรอกเบอร์โทรผู้ประสานงาน"),

        // fLicense: Yup.mixed().required("กรุณาแนบไฟล์สำเนาหนังสือรับรองการจดทะเบียนนิติบุคคลพร้อมวัตถุประสงค์"),
        // entrepreneurName: Yup.string().when("checkedEntrepreneur", {
        //     is: true,
        //     then: Yup.string().required("กรุณากรอกชื่อผู้ประกอบกิจการ")
        // }),
        // companyNo: Yup.string().when("checkedEntrepreneur", {
        //     is: true,
        //     then: Yup.string().min(10, "เลขที่บัญชีนายจ้างต้องมีจำนวน 10 หลัก").required("กรุณากรอกเลขที่บัญชีนายจ้าง (10หลัก)"),
        // }),
        // subIndustry: Yup.string().when("checkedEntrepreneur", {
        //     is: true,
        //     then: Yup.string().required("กรุณาเลือกประเภทอุตสาหกรรม (หมวดย่อย 2 หลัก)"),
        // }),
        // industryId: Yup.string().when("checkedEntrepreneur", {
        //     is: true,
        //     then: Yup.string().required("กรุณาเลือกประเภทอุตสาหกรรม (กิจกรรม 5 หลัก)"),
        // }),
        // businessType: Yup.string().when("checkedEntrepreneur", {
        //     is: true,
        //     then: Yup.string().required("กรุณากรอกประกอบกิจการประเภท"),
        // }),
        // // fMap: Yup.mixed(),
        // fMap: Yup.mixed().when("checkedEntrepreneur", {
        //     is: true,
        //     then: Yup.mixed().required("กรุณาแนบไฟล์แผนที่ตั้งสถานประกอบกิจการ"),
        // }),
        customerNo: Yup.string()
            .min(13, "เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ ต้องมีจำนวน 13 หลัก")
            .required(
                "กรุณากรอกเลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ (13หลัก)"
            ),

    })

    const prefix = "ศูนย์ประเมินความรู้ความสามารถ ";




    //ดึงข้อมูล อำเภอ ตำบล แบบ default เพื่อเอามาโชว์
    useEffect(() => {

        async function CheckCertificateNo() {
            try {
                const res = await fetch("/api/Registeration/getCertificateNo", {
                    method: "POST",
                    headers: { "Content-type": "application/json" },
                    body: JSON.stringify({
                        "certificateNo": profileData?.licenseNo ?? ""
                    }),
                });

                let resJson = await res.json();
                if (resJson.dataenum !== null) {
                    let centerName = resJson.dataenum.centerName || "";

                    // ตรวจสอบว่ามีคำว่า 'ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน' หรือยัง
                    if (!centerName.includes("ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน")) {
                        centerName = `ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน ${centerName}`;
                    }

                    setDataCertificate(resJson.dataenum)
                }
            } catch (err) {
                console.log(err)
            }
        }

        async function GetAmphur() {
            // console.log(e.target.value);
            let postData = new FormData();
            postData.append("provinceCode", profileData.address.provinceCode);

            try {
                const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                    method: "POST",
                    body: postData
                });
                const amphurData = await responseAmphur.json()
                setLocationAmphur(amphurData.dataenum);
                // console.log(amphurData.dataenum);

            } catch (err) {
                // console.log("err =>" + err);
            }
        }

        async function GetTumbon() {
            let postData = new FormData();
            postData.append("provinceCode", profileData.address.provinceCode);
            postData.append("amphurCode", profileData.address.amphurCode);
            try {
                let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                    method: "POST",
                    body: postData
                });
                const tumbonData = await responseTumbon.json()
                // setLocationTumbon(tumbonData.dataenum);
                setLocationTumbon(tumbonData.dataenum);

            } catch (err) {
                // console.log("err =>" + err);
            }
        };

        async function GetIndustry() {
            if (profileData.subIndustry != null) {
                let postData = new FormData();
                postData.append("industrialCode", profileData?.subIndustry);
                try {
                    let res = await fetch("/api/MasterData/getIndustry", {
                        method: "POST",
                        body: postData
                    });
                    const industryData = await res.json()
                    setIndustryData(industryData.dataenum);

                } catch (e) {
                    // console.log("err =>" + e);
                }
            } else {
                return;
            }
        };

        GetAmphur();
        GetTumbon();
        CheckCertificateNo();
        GetIndustry();
    }, [profileData])


    //modal ของเพิ่มข้อมูลผู้มีอำนาจ
    const initialEmptyPerson = {
        authRegisterId: 0,
        authTitleId: "",
        authFullName: "",
        authPersonalId: "",
        authAddressNo: "",
        authAddressMoo: "",
        authAddressSoi: "",
        authAddressStreet: "",
        authAddressProvince: "",
        authAddressDistrict: "",
        authAddressTumbon: "",
        authAddressPostCode: "",
        authAddressLocationId: ""
    };

    const [modalOpen, setModalOpen] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [editMode, setEditMode] = useState("add");
    const [editData, setEditData] = useState(initialEmptyPerson);


    if (loading) { return <Loading /> }
    return (
        <Formik
            initialValues={profileData}
            // validationSchema={validateSchema}
            onSubmit={onSubmit}
            enableReinitialize

        >
            {(formik) => {

                async function GetAmphur(e) {
                    if (e) {
                        let { value } = e.target;
                        // console.log(e.target.value);
                        let postData = new FormData();
                        postData.append("provinceCode", value);

                        try {
                            const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                                method: "POST",
                                body: postData
                            });
                            const amphurData = await responseAmphur.json()
                            setLocationAmphur(amphurData.dataenum);
                            // console.log(amphurData.dataenum);

                        } catch (err) {
                            // console.log("err =>" + err);
                        }
                    } else {
                        return;
                    }
                }
                // ดึง master data ตำบล
                async function GetTumbon(e) {
                    if (e) {
                        let postData = new FormData();
                        postData.append("provinceCode", formik.values.address.provinceCode);
                        postData.append("amphurCode", e.target.value);
                        try {
                            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                                method: "POST",
                                body: postData
                            });
                            const tumbonData = await responseTumbon.json()
                            // setLocationTumbon(tumbonData.dataenum);
                            setLocationTumbon(tumbonData.dataenum);

                        } catch (err) {
                            // console.log("err =>" + err);
                        }

                    } else {
                        return;
                    }
                };
                // หา location_id โดยส่ง จังหวัด อำเภอ ตำบล ไปหา เพื่อที่จะเอามาเก็บใน data base เป็น location_id
                async function GetLocationsId(e) {

                    let tumbonId = e.target.value;
                    let provinceId = formik.values.address.provinceCode;
                    let amphurId = formik.values.address.amphurCode;

                    let postData = new FormData();
                    postData.append("provinceCode", provinceId);
                    postData.append("amphurCode", amphurId);
                    postData.append("tumbonCode", tumbonId);
                    try {
                        let res = await fetch("/api/MasterData/getLocationId", {
                            method: "POST",
                            body: postData
                        });
                        const locationId = await res.json()

                        let setLocationId = locationId.dataenum.map(({ locationId }) => locationId).join().toString();
                        formik.setFieldValue('address.locationId', setLocationId)

                    } catch (err) {
                        // console.log("err =>" + err);
                    }
                }
                // ดึง master data ประเภทกิจกรรม 5 หลัก 
                async function GetIndustry(e) {
                    if (e) {
                        let postData = new FormData();
                        postData.append("industrialCode", e.target.value);
                        try {
                            let res = await fetch("/api/MasterData/getIndustry", {
                                method: "POST",
                                body: postData
                            });
                            const industryData = await res.json()
                            setIndustryData(industryData.dataenum);

                        } catch (e) {
                            // console.log("err =>" + e);
                        }
                    } else {
                        return;
                    }
                };

                const getTitleName = (titleCode) => {
                    const isTitleName = titleName?.find(title => title.titleCode == titleCode);
                    if (isTitleName) {
                        return isTitleName?.titleThai;
                    }
                    return " ";
                }

                const isAuthorizedListChanged = () => {
                    const current = formik.values?.authorizedList || [];

                    // เปรียบเทียบจำนวน (เพิ่ม/ลบ)
                    if (current.length !== originalAuthorizedList.length) return true;

                    // เปรียบเทียบแต่ละรายการ (แก้ไข)
                    for (let i = 0; i < current.length; i++) {
                        if (JSON.stringify(current[i]) !== JSON.stringify(originalAuthorizedList[i])) {
                            return true;
                        }
                    }

                    return false;
                };

                const handleSubmit = (e) => {
                    e.preventDefault();
                    if (isAuthorizedListChanged() && !registerationDoc) {
                        Swal.fire({
                            icon: 'error',
                            // title: 'ลงทะเบียนไม่สำเร็จ',
                            html: "กรุณาแนบหนังสือจดทะเบียนนิติบุคคล หากมีการเพิ่ม ลบ หรือแก้ไขผู้มีอำนาจ",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                        return;
                    }
                    if (Object.keys(formik.errors).length > 0) {
                        // form has errors
                        let errorText = "";
                        for (const error in formik.errors) {
                            errorText += `<h6>${formik.errors[error]}</h6>`;
                        }
                        Swal.fire({
                            icon: 'error',
                            title: 'ลงทะเบียนไม่สำเร็จ',
                            html: errorText,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                        // set invalid state of form inputs
                        for (const field in formik.errors) {
                            formik.setFieldTouched(field, true);
                        }
                    } else {
                        formik.handleSubmit(e);
                    }
                }

                return (

                    <Container className="d-flex justify-content-center mb-5">
                        <div className="form-border">

                            <Form
                                className="p-5 mb-4"
                                onSubmit={handleSubmit}
                                autoComplete="off"
                            >
                                <FormGroup className="mt-5 d-flex justify-content-start">
                                    <Label
                                        for="customerTypeAr"
                                        name="customerTypeAr">
                                        ประเภทผู้ใช้งาน

                                    </Label>
                                </FormGroup>
                                <div className="ms-5">
                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type`}
                                            value="1"
                                            name="entrepreneur"
                                            disabled
                                            checked={profileData?.registerTypeId.some(item => item === 1)}
                                        // onClick={HandleChecked} 
                                        />
                                        <Label>ผู้ประกอบกิจการ</Label>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type`}
                                            name="trainer"
                                            value="2"
                                            disabled
                                            checked={profileData?.registerTypeId.some(item => item === 2)}
                                        // onClick={HandleChecked} 
                                        />
                                        <Label>ผู้ดำเนินการฝึก</Label>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type`}
                                            name="skillTesting"
                                            value="3"
                                            disabled
                                            checked={profileData?.registerTypeId.some(item => item === 3)}
                                        // onClick={HandleChecked}
                                        />
                                        <Label>ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type`}
                                            name="groupOfEntrepreneur"
                                            value="4"
                                            disabled
                                            checked={profileData?.registerTypeId.some(item => item === 4)}
                                        // onClick={HandleChecked} 
                                        />
                                        <Label>กลุ่มผู้ประกอบกิจการ</Label>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input
                                            type="checkbox"
                                            className={`mx-2 cus-type`}
                                            name="estimate"
                                            value="5"
                                            disabled
                                            checked={profileData?.registerTypeId.some(item => item === 5)}
                                        // onClick={HandleChecked} 
                                        />
                                        <Label>ศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)</Label>
                                    </FormGroup>
                                </div>

                                {/* input สำหรับใส่เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ 13 หลัก */}
                                <Row>
                                    <Label
                                        for="customer_no">เลขทะเบียนนิติบุคคล/เลขทะเบียนพาณิชย์ (13หลัก)
                                        {formik.touched.customerNo && formik.errors.customerNo ?
                                            <span className="text-left text-danger px-3">
                                                {formik.errors.customerNo}
                                            </span> : null
                                        }
                                    </Label>
                                    <br />
                                    <Col>
                                        <Field name="customerNo">
                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                <NumericFormat
                                                    allowLeadingZeros
                                                    maxLength={13}
                                                    displayType="number"
                                                    value={values?.customerNo ?? "-"}
                                                    onValueChange={(values, sourceInfo) => {
                                                        setFieldValue(field.name, values.value)
                                                    }}
                                                    customInput={CustomInputNumeric}
                                                    className={formik.errors.customerNo && formik.touched.customerNo ? "input-error" : ""}
                                                    disabled
                                                />
                                            )}
                                        </Field>
                                    </Col>
                                </Row>

                                {/* input สำหรับใส่ ข้อมูลเมื่อคลิกเป็นผู้ประกอบกิจการ */}
                                {profileData?.registerTypeId.some(type => type === 1) ? (
                                    <>
                                        <FormGroup className="pt-3">
                                            <Label
                                                for="customer_name">ชื่อผู้ประกอบกิจการ

                                                {formik.touched.entrepreneurName && formik.errors.entrepreneurName ?
                                                    <span
                                                        className="text-left text-danger px-3">
                                                        {formik.errors.entrepreneurName}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className={formik.touched.entrepreneurName && formik.errors.entrepreneurName ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="entrepreneurName"
                                                    {...formik.getFieldProps("entrepreneurName")}
                                                // onBlur={formik.handleBlur}
                                                // onChange={formik.handleChange}
                                                // value={formik.values.entrepreneurName}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup className="pt-3">
                                            <Label
                                                for="companyNo">เลขที่บัญชีผู้ประกอบกิจการ (10หลัก)

                                                {formik.touched.companyNo && formik.errors.companyNo ?
                                                    <span
                                                        className="text-left text-danger px-3">
                                                        {formik.errors.companyNo}
                                                    </span>
                                                    : null
                                                }
                                            </Label>
                                            {/* <br /> */}
                                            <Col>
                                                <Field name="companyNo">
                                                    {({ field, meta, form: { setFieldValue, values } }) => (
                                                        <NumericFormat
                                                            allowLeadingZeros
                                                            maxLength={10}
                                                            displayType="number"
                                                            value={values?.companyNo ?? "-"}
                                                            onValueChange={(values, sourceInfo) => {
                                                                setFieldValue(field.name, values.value)
                                                            }}
                                                            customInput={CustomInputNumeric}
                                                            disabled
                                                            className={formik.errors.companyNo && formik.touched.companyNo ? "input-error" : ""}
                                                        />
                                                    )}
                                                </Field>
                                            </Col>
                                        </FormGroup>
                                    </>
                                ) : null}

                                {/* input สำหรับกรณีเลือก ผู้ดำเนินการฝึก " จะให้กรอกชื่อผู้ดำเนินการฝึกแค่ครั้งเดียว */}
                                {/* {showName ? ( */}
                                {profileData?.registerTypeId.some(item => item === 2) ? (
                                    <>
                                        <FormGroup className="pt-3">
                                            <Label
                                                for="customer_name">ชื่อผู้ดำเนินการฝึก

                                                {formik.touched.licenseName && formik.errors.licenseName ?
                                                    <span className="text-left text-danger px-3">
                                                        {formik.errors.licenseName}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className=
                                                    {formik.touched.licenseName && formik.errors.licenseName ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="licenseName"
                                                    {...formik.getFieldProps("licenseName")}
                                                    disabled
                                                />
                                            </Col>
                                        </FormGroup>
                                    </>
                                ) : null}


                                {/* input เมื่อเลือกเป็น ศูนย์ประเมินความรู้ความสามารถ */}
                                {profileData?.registerTypeId.some(item => item === 5) ? (
                                    <>
                                        <FormGroup className="pt-3">
                                            <Label
                                                for="certificate26Name">ชื่อศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)

                                                {formik.touched.certificate26Name && formik.errors.certificate26Name ?
                                                    <span className="text-left text-danger px-3">
                                                        {formik.errors.certificate26Name}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className={formik.touched.certificate26Name && formik.errors.certificate26Name ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="certificate26Name"
                                                    {...formik.getFieldProps("certificate26Name")}
                                                    onChange={(e) => {
                                                        const input = e.target.value;
                                                        // ถ้าเริ่มด้วย prefix แล้ว ให้ใช้ตามนั้น
                                                        if (input.startsWith(prefix)) {
                                                            formik.setFieldValue("certificate26Name", input);
                                                        } else {
                                                            // ถ้าผู้ใช้พยายามลบ prefix หรือกรอกใหม่ ให้เติม prefix กลับเข้าไป
                                                            const suffix = input.replace(prefix, "");
                                                            formik.setFieldValue("certificate26Name", prefix + suffix);
                                                        }
                                                    }}
                                                    disabled
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup
                                            row
                                            className="pt-3" >
                                            <Label
                                                for="certificate26No">
                                                เลขที่หนังสือรับรองการเป็นศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)
                                                {formik.touched.certificate26No && formik.errors.certificate26No ?
                                                    <span className="text-left text-danger px-1">
                                                        {formik.errors.certificate26No}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className=
                                                    {formik.touched.certificate26No && formik.errors.certificate26No ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="certificate26No"
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange}
                                                    disabled
                                                    value={formik.values?.certificate26No ?? "-"}
                                                />
                                            </Col>
                                        </FormGroup>
                                    </>
                                ) : null}

                                {/* input เมื่อเลือกเป็น กลุ่มผู้ประกอบกิจการ */}
                                {/* {checkedGroupOfEntrepreneur && ( */}
                                {profileData?.registerTypeId.some(item => item === 4) ? (
                                    <>
                                        <FormGroup className="pt-3">
                                            <Label
                                                for="customer_name">ชื่อ (โปรดระบุชื่อ กลุ่มผู้ประกอบกิจการ)

                                                {formik.touched.groupcompanyName && formik.errors.groupcompanyName ?
                                                    <span
                                                        className="text-left text-danger px-3">
                                                        {formik.errors.groupcompanyName}
                                                    </span> : null
                                                }
                                            </Label>
                                            <br />
                                            <Col>
                                                <Input
                                                    className=
                                                    {formik.touched.groupcompanyName && formik.errors.groupcompanyName ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="groupcompanyName"
                                                    {...formik.getFieldProps("groupcompanyName")}
                                                    disabled
                                                />
                                            </Col>
                                        </FormGroup>

                                    </>
                                ) : null}


                                {/* input เมื่อเลือกเป็น ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน */}
                                {/* {checkedSkillTesting && ( */}
                                {profileData?.registerTypeId.some(item => item === 4) ? (
                                    <div>
                                        <div>
                                            <FormGroup
                                                row
                                                className="pt-3" >
                                                <Label
                                                    for="test_license_no">
                                                    ชื่อ (โปรดระบุชื่อ ผู้ดำเนินการทดสอบ)

                                                    {formik.touched.licenseTestName && formik.errors.licenseTestName ?
                                                        <span className="text-left text-danger px-1">
                                                            {formik.errors.licenseTestName}
                                                        </span> : null
                                                    }
                                                </Label>
                                                <br />
                                                <Col>
                                                    <Input
                                                        className=
                                                        {formik.touched.licenseTestName && formik.errors.licenseTestName ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        type="text"
                                                        name="licenseTestName"
                                                        disabled
                                                        {...formik.getFieldProps("licenseTestName")}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup
                                                row
                                                className="pt-2" >
                                                <Label
                                                    for="test_license_no">
                                                    เลขที่ใบอนุญาตการเป็นผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน

                                                    {formik.touched.licenseNo && formik.errors.licenseNo ?
                                                        <span className="text-left text-danger px-1">
                                                            {formik.errors.licenseNo}
                                                        </span> : null
                                                    }
                                                </Label>
                                                <div className="d-flex">
                                                    <Input
                                                        type="text"
                                                        name="licenseNo"
                                                        {...formik.getFieldProps("licenseNo")}
                                                        // value={certificate24}
                                                        className={
                                                            formik.touched.licenseNo && formik.errors.licenseNo ?
                                                                "input-error rounded-pill rounded-end text-center input-color" :
                                                                "rounded-pill rounded-end text-center input-color"
                                                        }
                                                        disabled
                                                    />

                                                </div>

                                            </FormGroup>
                                        </div>
                                    </div>
                                ) : null}


                                {dataCertificate !== null ?
                                    <>
                                        <div className="cus-type mx-2">
                                            <div className="my-3 px-3">
                                                <h4 className="text-center input-color">ข้อมูลศูนย์ทดสอบมาตรฐานฝีมือแรงงาน</h4>
                                                <Label className="">ชื่อศูนย์ทดสอบมาตรฐานฝีมือแรงงาน : <span className="input-color">{dataCertificate.centerName}</span></Label>
                                                <Label className="mt-2">ชื่อหน่วยงานกรมพัฒนาฝีมือแรงงานในพื้นที่ที่ศูนย์ฝึกอบรมฝีมือแรงงาน: </Label>
                                                <Input
                                                    disabled={true}
                                                    className="rounded-pill text-center input-color"
                                                    value={dataCertificate.site}
                                                />
                                                <Label className="mt-2 w-100 mt-2">วันที่เริ่มดำเนินงาน : <span className="input-color">{dataCertificate.dateCreate}</span></Label>
                                                <Label className="mt-2 w-100 mt-2">สถานะการดำเนินงาน : <span className="input-color">{dataCertificate.workOn === "1" ? "ยังดำเนินการอยู่" : ""}</span></Label>

                                                <div className="mt-2">
                                                    <Label>ที่อยู่ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน:
                                                        <span className="input-color mx-1">{dataCertificate?.address ?? "-"}</span>
                                                        เบอร์โทร : <span className="input-color mx-1">{dataCertificate?.telNo ?? "-"}</span>
                                                        อีเมล : <span className="input-color mx-1">{dataCertificate?.email ?? "-"}</span>
                                                        {/* จังหวัด <span className="input-color mx-1">{dataCertificate.provinceName}</span>
                                                        อำเภอ/เขต <span className="input-color mx-1">{dataCertificate.amphurName}</span>
                                                        ตำบล/แขวง <span className="input-color mx-1">{dataCertificate.tumbonName}</span> */}
                                                    </Label>
                                                </div>
                                            </div>
                                        </div>


                                    </> : null}

                                {/* input สำหรับใส่ที่อยู่ */}
                                <div className="pt-3" >
                                    <Label
                                        for="address">ที่อยู่

                                        {formik.touched?.address?.addressNo && formik.errors?.address?.addressNo ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors?.address?.addressNo}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.address?.moo && formik.errors.address?.moo ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.address?.moo}
                                            </span>
                                            : null
                                        }

                                        {formik.touched.address?.provinceCode && formik.errors.address?.provinceCode ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.address?.provinceCode}
                                            </span>
                                            : null
                                        }

                                        {formik.touched.address?.amphurCode && formik.errors.address?.amphurCode ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.address?.amphurCode}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.address?.tumbonCode && formik.errors.address?.tumbonCode ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.address?.tumbonCode}
                                            </span>
                                            : null
                                        }
                                        {formik.touched.address?.postCode && formik.errors.address?.postCode ?
                                            <span
                                                className="text-left text-danger px-1">
                                                {formik.errors.address?.postCode}
                                            </span>
                                            : null
                                        }
                                    </Label>
                                    <div className="px-4 pt-4">
                                        <FormGroup row>
                                            <Label
                                                for="addNo"
                                                sm={2}
                                            >
                                                เลขที่
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="address.addressNo"
                                                    name="address.addressNo"
                                                    type="text"
                                                    className=
                                                    {formik.touched?.address?.addressNo && formik.errors?.address?.addressNo ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("address.addressNo")}
                                                    disabled
                                                />
                                            </Col>

                                            <Label
                                                for="moo"
                                                sm={2}
                                            >
                                                หมู่ที่
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="address.moo"
                                                    name="address.moo"
                                                    type="text"
                                                    className=
                                                    {formik.touched?.address?.moo && formik.errors?.address?.moo ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("address.moo")}
                                                    disabled

                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="soi"
                                                sm={2}
                                            >
                                                ซอย
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="address.soi"
                                                    name="address.soi"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    {...formik.getFieldProps("address.soi")}
                                                    disabled
                                                />
                                            </Col>

                                            <Label
                                                for="street"
                                                sm={2}
                                            >
                                                ถนน
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="address.street"
                                                    name="address.street"
                                                    type="text"
                                                    className="rounded-pill text-center input-color"
                                                    // onChange={formik.handleChange}
                                                    // value={formik.values.addStreet}
                                                    {...formik.getFieldProps("address.street")}
                                                    disabled
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="address.provinceCode"
                                                sm={2}
                                            >
                                                จังหวัด
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="address.provinceCode"
                                                    name="address.provinceCode"
                                                    type="select"
                                                    className=
                                                    {formik.touched?.address?.provinceCode && formik.errors?.address?.provinceCode ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("address.provinceCode")}
                                                    // onBlur={formik.handleBlur}
                                                    onChange={(e) => {
                                                        console.log("eerer", e.target.value)
                                                        formik.handleChange(e)
                                                        formik.setFieldValue("address.amphurCode", "กรุณาเลือกอำเภอ/เขต");
                                                        formik.setFieldValue("address.tumbonCode", "กรุณาเลือกตำบล/แขวง");
                                                        GetAmphur(e)
                                                    }}
                                                    disabled
                                                // value={formik.values.addProvince}
                                                >
                                                    <option defaultValue="กรุณาเลือกจังหวัด">
                                                        กรุณาเลือกจังหวัด
                                                    </option>
                                                    {locationProvince.map(province => (
                                                        <option
                                                            key={province.provinceCode}
                                                            value={province.provinceCode}
                                                        >
                                                            {province.provinceName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>

                                            <Label
                                                for="district_id"
                                                sm={2}
                                            >
                                                อำเภอ/เขต
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="address.amphurCode"
                                                    name="address.amphurCode"
                                                    type="select"
                                                    className=
                                                    {formik.touched?.address?.amphurCode && formik.errors?.address?.amphurCode ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("address.amphurCode")}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        formik.setFieldValue("address.tumbonCode", "กรุณาเลือกตำบล/แขวง");
                                                        GetTumbon(e)
                                                    }}
                                                    disabled

                                                >
                                                    <option defaultValue="กรุณาเลือกอำเภอ/เขต" >
                                                        กรุณาเลือกอำเภอ/เขต
                                                    </option>
                                                    {locationAmphur.map(amphur => (
                                                        <option
                                                            key={amphur.amphurCode}
                                                            value={amphur.amphurCode}>
                                                            {amphur.amphurName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Label
                                                for="addTumbon"
                                                sm={2}
                                            >
                                                ตำบล/แขวง
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    id="address.tumbonCode"
                                                    name="address.tumbonCode"
                                                    type="select"
                                                    className=
                                                    {formik.touched?.address?.tumbonCode && formik.errors?.address?.tumbonCode ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("address.tumbonCode")}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        GetLocationsId(e)
                                                    }}
                                                    disabled

                                                // value={formik.values.addTumbon}
                                                >
                                                    <option defaultValue="กรุณาเลือกตำบล/แขวง">
                                                        กรุณาเลือกตำบล/แขวง
                                                    </option>
                                                    {locationTumbon.map(tumbon => (
                                                        <option
                                                            key={tumbon.tumbonCode}
                                                            value={tumbon.tumbonCode}
                                                        >
                                                            {tumbon.tumbonName}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </Col>

                                            <Label
                                                for="postcode"
                                                sm={2}
                                            >
                                                รหัสไปรษณีย์
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <Col sm={4}>
                                                <Input
                                                    maxLength={5}
                                                    id="address.postCode"
                                                    name="address.postCode"
                                                    type="text"
                                                    className=
                                                    {formik.touched?.address?.postCode && formik.errors?.address?.postCode ?
                                                        "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                    }
                                                    {...formik.getFieldProps("address.postCode")}
                                                    disabled
                                                />
                                            </Col>
                                        </FormGroup>
                                    </div>
                                </div>

                                {/* input สำหรับใส่เบอร์โทรศัพท์และโทรสาร */}
                                <Row className="pt-3">
                                    <Col>
                                        <Label
                                            for="tel">โทรศัพท์
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {formik.touched?.phone && formik.errors?.phone
                                                ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors?.phone}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className=
                                                {formik.touched.phone && formik.errors.phone ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="phone"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values?.phone ?? "-"}
                                            />
                                        </Col>
                                    </Col>

                                    <Col>
                                        <Label for="fax">
                                            โทรสาร
                                            {formik.touched.fax && formik.errors.fax ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors.fax}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className=
                                                {formik.touched.fax && formik.errors.fax ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="fax"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values?.fax ?? "-"}
                                            />
                                        </Col>
                                    </Col>
                                </Row>

                                {/* input สำหรับใส่ email ชื่อ-นามสกุล เบอร์โทรผู้ประสานงาน */}
                                <FormGroup className="pt-3">
                                    <Label
                                        for="email">
                                        อีเมล
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                        {formik.touched.email && formik.errors.email ?
                                            <span className="text-left text-danger px-1">
                                                {formik.errors.email}
                                            </span> : null
                                        }
                                    </Label>
                                    <br />
                                    <Col>
                                        <Input
                                            className=
                                            {formik.touched.email && formik.errors.email ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            type="text"
                                            name="email"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values?.email ?? "-"}
                                            autoComplete="off"
                                        />
                                    </Col>
                                </FormGroup>

                                <Row className="pt-3">
                                    <Col>
                                        <Label
                                            for="contactName">
                                            ชื่อ-นามสกุลผู้ประสานงาน
                                            <span className="require-input">
                                                *
                                            </span>
                                            {formik.touched.contactorName && formik.errors.contactorName ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors.contactorName}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className=
                                                {formik.touched.contactorName && formik.errors.contactorName ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="contactorName"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                value={formik.values?.contactorName ?? "-"}

                                            />
                                        </Col>
                                    </Col>

                                    <Col>
                                        <Label
                                            for="contactNo">
                                            หมายเลขโทรศัพท์ผู้ประสานงาน
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {formik.touched.contactorPhone && formik.errors.contactorPhone ?
                                                <span className="text-left text-danger px-1">
                                                    {formik.errors.contactorPhone}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className={formik.touched.contactorPhone && formik.errors.contactorPhone ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="contactorPhone"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                value={formik.values?.contactorPhone ?? "-"}
                                            />
                                        </Col>
                                    </Col>
                                </Row>

                                {/* {checkedEntrepreneur || checkedSkillTesting || checkedEstimate ? ( */}
                                {profileData?.registerTypeId.some(item => item === 1) || profileData?.registerTypeId.some(item => item === 3) || profileData?.registerTypeId.some(item => item === 5) ? (
                                    <>
                                        <div className="mt-4">
                                            <FieldArray name="authorizedList">
                                                {({ push, remove, replace }) => (
                                                    <>
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <Label
                                                                for="address">ข้อมูลผู้มีอำนาจ
                                                                <span
                                                                    className="require-input">
                                                                    *
                                                                </span>
                                                            </Label>

                                                            <button
                                                                className="btn-blue create-button-form"
                                                                type="button"
                                                                // disabled={disableButton}
                                                                onClick={() => {
                                                                    setEditMode("add");
                                                                    setEditData(initialEmptyPerson);
                                                                    setModalOpen(true);
                                                                }}
                                                            >
                                                                <BsPlusLg className="mx-2" />
                                                                เพิ่มผู้มีอำนาจ
                                                            </button>
                                                        </div>

                                                        <Table className="styled-table mt-2" stype={{ backgroundColor: "#ffff" }} striped bordered>
                                                            <thead className="text-center">
                                                                <tr>
                                                                    <th>ลำดับ</th>
                                                                    {/* <th>คำนำหน้า</th> */}
                                                                    <th>ชื่อ - สกุล</th>
                                                                    <th>เลขบัตรประจำตัวประชาชน</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {formik.values?.authorizedList?.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan="6" className="text-center">
                                                                            ไม่มีข้อมูล
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    formik.values?.authorizedList?.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td className="text-center">{index + 1}</td>
                                                                            {/* <td>{item.authTitleId}</td> */}
                                                                            <td>{getTitleName(item.authTitleId)} {item.authFullName}</td>
                                                                            <td className="text-center">{item.authPersonalId}</td>
                                                                            {/* <td>{item.authAddressProvince}</td> */}
                                                                            <td className="text-center">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn border border-1 mx-1"
                                                                                    onClick={() => {
                                                                                        setEditMode("edit");
                                                                                        setEditIndex(index);
                                                                                        setEditData(item);
                                                                                        setModalOpen(true);
                                                                                    }}
                                                                                >
                                                                                    <FiEdit3 style={{ color: rootColorPrimary }} />
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn border border-1 mx-1"
                                                                                    onClick={() => remove(index)}

                                                                                >
                                                                                    <AiOutlineDelete style={{ color: rootColorErrors }} />
                                                                                </button>

                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                )}
                                                            </tbody>
                                                        </Table>

                                                        <AddEditAuthorizedModal
                                                            isOpen={modalOpen}
                                                            toggle={() => setModalOpen(false)}
                                                            mode={editMode}
                                                            initialData={editData}
                                                            onSubmit={(data) => {
                                                                if (editMode === "add") {
                                                                    push(data);
                                                                } else {
                                                                    replace(editIndex, data);
                                                                }
                                                            }}
                                                            copyAddressData={formik.values}
                                                        />
                                                    </>
                                                )}
                                            </FieldArray>

                                            {isAuthorizedListChanged() && (
                                                <div className="mt-3">
                                                    <Label for="registrationDoc" className="fw-bold">
                                                        แนบหนังสือจดทะเบียนนิติบุคคล<span className="require-input">*</span>
                                                    </Label>
                                                    <Input
                                                        type="file"
                                                        id="registrationDoc"
                                                        onChange={(e) => {
                                                            if (e.target.files?.[0]) {
                                                                setRegisterationDoc(e.target.files[0]);
                                                            }
                                                        }}
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                    />
                                                    {registerationDoc && (
                                                        <div className="mt-2 text-success">
                                                            อัปโหลดแล้ว: {registerationDoc.name}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                        </div>

                                    </>
                                ) : null}

                                {/* input เมื่อเลือกเป็น ผู้ประกอบกิจการ */}
                                {/* {checkedEntrepreneur && ( */}
                                {profileData?.registerTypeId.some(type => type === 1) ? (
                                    <div>
                                        <div className="pt-3">
                                            <Label
                                                for="industry_type">
                                                ประเภทอุตสาหกรรม
                                                <span
                                                    className="require-input">
                                                    *
                                                </span>
                                            </Label>
                                            <div className="px-4 pt-4">
                                                <Row>
                                                    <Label
                                                        for="industryType">
                                                        หมวดย่อย (2หลัก)
                                                        {formik.touched.subIndustry && formik.errors.subIndustry ?
                                                            <span className="text-left text-danger px-1">
                                                                {formik.errors.subIndustry}
                                                            </span>
                                                            : null
                                                        }
                                                    </Label>

                                                    <Col>
                                                        <Input
                                                            id="subIndustry"
                                                            name="subIndustry"
                                                            type="select"
                                                            className=
                                                            {formik.touched.subIndustry && formik.errors.subIndustry ?
                                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={formik.handleBlur}
                                                            onChange={(e) => {
                                                                formik.handleChange(e)
                                                                GetIndustry(e)
                                                            }}
                                                            value={formik.values?.subIndustry ?? "-"}
                                                            disabled

                                                        >
                                                            <option defaultValue value={"กรุณาเลือกประเภทอุตสาหกรรม (หมวดย่อย 2 หลัก)"}>
                                                                กรุณาเลือกประเภทอุตสาหกรรม (หมวดย่อย 2 หลัก)
                                                            </option>
                                                            {industrialData.map(industrial => (
                                                                <option
                                                                    key={industrial.industrialCodeNew}
                                                                    value={industrial.industrialCodeNew}
                                                                >
                                                                    {industrial.industrialCodeNew}-{industrial.industrialDescNew}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                </Row>

                                                <Row className="mt-3">
                                                    <Label
                                                        for="industryId">
                                                        กิจกรรม (5หลัก)
                                                        {formik.touched.industryId && formik.errors.industryId ?
                                                            <span className="text-left text-danger px-1">
                                                                {formik.errors.industryId}
                                                            </span> : null
                                                        }
                                                    </Label>
                                                    <Col>
                                                        <Input
                                                            id="industryId"
                                                            name="industryId"
                                                            type="select"
                                                            className=
                                                            {formik.touched.industryId && formik.errors.industryId ?
                                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={formik.handleBlur}
                                                            onChange={formik.handleChange}
                                                            value={formik.values?.industryId ?? "-"}
                                                            disabled

                                                        >
                                                            <option defaultValue value={"กรุณาเลือกประเภทอุตสาหกรรม (กิจกรรม 5 หลัก)"}>
                                                                กรุณาเลือกประเภทอุตสาหกรรม (กิจกรรม 5 หลัก)
                                                            </option>

                                                            {industryData.map(industry => (
                                                                <option
                                                                    key={industry.indusCode}
                                                                    value={industry.indusCode}>
                                                                    {industry.indusCode}-{industry.indusTname}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>


                                        <Row className="pt-3">
                                            <Col>
                                                <Label
                                                    for="type_business">
                                                    ประกอบกิจการประเภท
                                                    <span className="require-input">
                                                        *
                                                    </span>
                                                    {formik.touched.businessType && formik.errors.businessType ?
                                                        <span className="text-left text-danger px-1">
                                                            {formik.errors.businessType}
                                                        </span> : null
                                                    }
                                                </Label>
                                                <Col>
                                                    <Input
                                                        type="text"
                                                        name="businessType"
                                                        id="businessType"
                                                        className=
                                                        {formik.touched.businessType && formik.errors.businessType ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={formik.handleBlur}
                                                        onChange={formik.handleChange}
                                                        value={formik.values?.businessType ?? "-"}
                                                        disabled
                                                    />
                                                </Col>
                                            </Col>

                                            <Col>
                                                <Label
                                                    for="employAmt">
                                                    มีลูกจ้างตั้งแต่ 100 คนขึ้นไป เมื่อวันที่
                                                </Label>
                                                <Col>
                                                    <Field name="employeeDate" disabled component={(props) => <DatePickerInput {...props} maxDate={new Date()} disable={true} />} />
                                                </Col>
                                            </Col>
                                        </Row>

                                    </div>
                                ) : null}

                                <div className="text-center p-5">
                                    <button
                                        className="submit-btn"
                                        type="submit">
                                        บันทึก
                                    </button>
                                </div>
                            </Form>
                        </div>
                    </Container>
                )
            }}

        </Formik>

    );
}
